export function normalizeEdgePercent(edge) {
  if (edge == null) return null;

  const value = Number(edge);
  if (!Number.isFinite(value)) return null;
  if (value >= 0 && value <= 1) return value * 100;
  return value;
}

export function isAllowedPublicEdge(edge) {
  const normalized = normalizeEdgePercent(edge);
  return normalized == null || normalized < 60;
}
